/**
 * Isolierte Firebase-App für das Projekt ohmyart-ai (Editor-Backend).
 * TaskDash läuft selbst auf driveconnector; Generation Monitor und /generate
 * brauchen zusätzlich einen Login in ohmyart-ai (E-Mail/Passwort), weil
 * Generierung, Uploads und Logs dort liegen.
 */
import { initializeApp, getApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAV8jI0EekE4OMuClaQiF4WpuJeqnZ2AMA",
  authDomain: "ohmyart-ai.firebaseapp.com",
  projectId: "ohmyart-ai",
  storageBucket: "ohmyart-ai.firebasestorage.app",
  messagingSenderId: "3734662653",
  appId: "1:3734662653:web:f087ef05b947f3c218fd94",
};
const APP_NAME = "gen_monitor_app";

export function getOhmyartApp() {
  const app = getApps().find((a) => a.name === APP_NAME) ? getApp(APP_NAME) : initializeApp(firebaseConfig, APP_NAME);
  return {
    app,
    auth: getAuth(app),
    db: getFirestore(app),
    storage: getStorage(app),
    // Editor-Functions liegen in europe-west1 (setGlobalOptions in ohmyart index.js)
    functions: getFunctions(app, "europe-west1"),
  };
}

/** Beispielbild eines Stils wie im Editor (app/examples/{style}/{ratio}/v{n}/{theme}.{webp|jpg}) */
export function styleExampleUrl(styleId, orientation, version, transparent, theme = "default") {
  const ratio = orientation === "landscape" ? "3:2" : "2:3";
  const ext = transparent ? "webp" : "jpg";
  const seg = version ? `v${encodeURIComponent(version)}%2F` : "";
  return `https://firebasestorage.googleapis.com/v0/b/ohmyart-ai.firebasestorage.app/o/app%2Fexamples%2F${encodeURIComponent(styleId)}%2F${encodeURIComponent(ratio)}%2F${seg}${encodeURIComponent(theme)}.${ext}?alt=media`;
}
